import React, { memo } from "react";
import useTableCtx from "../tableContext/useTableCtx";
import TableItem from "./TableItem";
import TableItemExtra from "../TableItemExtra";

function TableBody({
  ActionButtonsComponent,
}: {
  ActionButtonsComponent: any;
}) {
  const tableContext = useTableCtx()!;

  const { tableData } = tableContext;

  return (
    <tbody>
      {tableData?.length > 0 &&
        tableData?.map(({ id, data, crudData, extraData }) => {
          return (
            <React.Fragment key={id}>
              <TableItem
                tableItemId={id}
                crudData={crudData}
                tableItemData={data}
                ActionButtonsComponent={ActionButtonsComponent}
              />
              {extraData?.map((extraDataItem, idx) => {
                return (
                  <TableItemExtra
                    extraData={extraDataItem}
                    showActionColumn={!!ActionButtonsComponent}
                    key={idx}
                  />
                );
              })}
            </React.Fragment>
          );
        })}
    </tbody>
  );
}

export default memo(TableBody);
